import { useCartKeyContext } from '@/features/pos/components/Cart/contexts/CartKey'
import StorageService from '@/services/storage'
import { useApolloClient } from '@apollo/client'
import { useCallback } from 'react'

export const useClearOrder = (): (() => void) => {
    const { cartKey, clearCartKey, mode } = useCartKeyContext()

    const { cache } = useApolloClient()

    return useCallback(() => {
        clearCartKey()
        void StorageService.removeAutomaticContainerRemovals(mode)

        cache.evict({ id: cache.identify({ __typename: 'Cart', key: cartKey }) })
        cache.evict({ id: cache.identify({ __typename: 'OrderDraft' }) })
        cache.gc()
    }, [cache, cartKey, clearCartKey, mode])
}
